import { render, staticRenderFns } from "./widget_copy_free.vue?vue&type=template&id=4cb6c1f6&scoped=true&lang=pug&"
import script from "./widget_copy_free.vue?vue&type=script&lang=js&"
export * from "./widget_copy_free.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb6c1f6",
  null
  
)

export default component.exports